import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBServiceFutureRequestId } from '../../../../../../store/selectors';
import { SuccessStatus } from '../../../../components';

export const ServiceFutureRequestSuccessStatus = compose(
  connect((state) => ({
    id: getFTTBServiceFutureRequestId(state),
    shouldRender: !!getFTTBServiceFutureRequestId(state),
  })),
  withRenderFlag,
)(SuccessStatus);
